import { call, put, takeLatest } from 'redux-saga/effects';

import { api } from 'services/api';
import axios from 'axios';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import { PAGE_SIZE } from 'services/constants/env';
import { vatReimbursementStructure } from 'components/VatReimbursement/vat-reimbursement-structure';
import {
	getVatReimbursementsRequest,
	getVatReimbursementsSuccess,
	receiveVatReimbursementRequest,
	receiveVatReimbursementSuccess,
	updateCommentRequest,
	updateCommentSuccess,
} from './reducer';
import {
	TVatReimbursementsData,
	TVatReimbursementsRequest,
	TReceiveVatReimbursementRequest,
	TUpdateCommentRequest,
} from './types';

function* getVatReimbursementsSaga(action: PayloadAction<TVatReimbursementsRequest>) {
	try {
		const response: TVatReimbursementsData = yield call(
			api.vatReimbursement.getVatReimbursements,
			action.payload,
		);
		yield put(getVatReimbursementsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

function* receiveVatReimbursementSaga(action: PayloadAction<TReceiveVatReimbursementRequest>) {
	try {
		const response: TVatReimbursementsData = yield call(
			api.vatReimbursement.receiveVatReimbursement,
			action.payload,
		);
		yield put(receiveVatReimbursementSuccess(response));
		notificationContainer('Vat reimbursement received successfully', 'success');

		if (action.payload.getVatReimbursementsRequest) {
			yield put(getVatReimbursementsRequest(action.payload.getVatReimbursementsRequest));
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

function* updateCommentSaga(action: PayloadAction<TUpdateCommentRequest>) {
	try {
		const response: TVatReimbursementsData = yield call(
			api.vatReimbursement.updateComment,
			action.payload,
		);
		yield put(updateCommentSuccess(response));
		notificationContainer('Comment updated successfully', 'success');
		if (action.payload.getVatReimbursementsRequest) {
			yield put(getVatReimbursementsRequest(action.payload.getVatReimbursementsRequest));
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

export function* vatReimbursementsSaga() {
	yield takeLatest(getVatReimbursementsRequest, getVatReimbursementsSaga);
	yield takeLatest(receiveVatReimbursementRequest, receiveVatReimbursementSaga);
	yield takeLatest(updateCommentRequest, updateCommentSaga);
}
